import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import Prototype from './Prototype';
import Background from '../../images/openSource/background.webp';
import Atlantico from '../../images/openSource/atlantico.png';
import Mass from '../../images/openSource/icons/mass.png';
import Battery from '../../images/openSource/icons/battery.png';
import Length from '../../images/openSource/icons/length.png'; 
import HB from '../../images/openSource/hb.webp';
import ES from '../../images/openSource/es.webp';  
import MS from '../../images/openSource/ms.webp';


function OpenSource() {
  const prototypes = [
    {
      title: 'Atlântico',
      description: 'Atlântico is a sustainable prototype fully powered by solar energy, using high-efficiency solar panels to supply its electric motor with zero CO2 emissions. The boat is built primarily from eco-friendly and sustainable materials, reflecting the team\'s commitment to innovation and environmental responsibility.',
      background: Background,
      atlantico: Atlantico,
      topics: [
        {
          title: 'MASS',
          icon: Mass,
          value: '300 kg',
        },
        {
          title: 'LENGTH',
          icon: Length,
          value: '6 m',
        },
        {
          title: 'BATTERY POWER',
          icon: Battery,
          value: '1.5 kWh',
        },
      ],

      es: {
        title: 'Electrical Systems',
        image: ES,
        link: '',
        topics: [
          {
            link: '/OpenSource/es/EmbeddedSystem.pdf',
            topic: 'Embedded System'
          },
          {
            link: '/OpenSource/es/SolarPanels.pdf',
            topic: 'Solar Panels'
          },
        ],
      },
      hb: {
        title: 'Hull & Body',
        image: HB,
        link: '',
        topics: [
          {
            link: '/OpenSource/hb/Bench.pdf',
            topic: 'Bench'
          },
          {
            link: '/OpenSource/hb/CompositeManufacturing.pdf',
            topic: 'Composite Manufacturing'
          },
          {
            link: '/OpenSource/hb/Powerribs.pdf',
            topic: 'Powerribs'
          },
          {
            link: '/OpenSource/hb/FlaxFiber.pdf',
            topic: 'Reinforcement Methods'
          },
          {
            link: '/OpenSource/hb/Epoxy.pdf',
            topic: 'Structural Analysis'
          },
        ],
      },
      ms: {
        title: 'Mechanical Systems',
        image: MS,
        link: '',
        topics: [
          {
            link: '/OpenSource/ms/Hydrofoil.pdf',
            topic: 'Hydrofoils'
          },
          {
            link: '/OpenSource/ms/Propeller.pdf',
            topic: 'Propeller'
          },
          {
            link: '/OpenSource/ms/PropulsionColumn.pdf',
            topic: 'Propulsion Column'
          },
          {
            link: '/OpenSource/ms/RudderSystem.pdf',
            topic: 'Rudder System'
          },
        ],
      },
    }
  ];

  

  return (
  <div className="w-full min-h-screen">
    {prototypes.length === 1 ? (
      <Prototype prototype={prototypes[0]} />
    ) : (
      <Slide slidesToScroll={1} slidesToShow={1} indicators={prototypes.length > 1} canSwipe={prototypes.length > 1}>
        {prototypes.map((prototype, index) => (
          <div key={index}>
            <Prototype prototype={prototype} />
          </div>
        ))}
      </Slide>
    )}
  </div>
);
}

export default OpenSource;
